import React, { useState } from 'react';
import PropTypes from 'prop-types';

import TextField from './TextField';

const PasswordField = ({
  value,
  type,
  ...props
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <TextField
      icon={visible ? 'eye-slash' : 'eye'}
      iconProps={{
        style: {
          transform: 'translateY(-50%)',
          cursor: 'pointer',
        },
        onClick: () => setVisible(!visible),
      }}
      value={value}
      type={visible ? 'text' : type}
      {...props}
    />
  );
};

PasswordField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  onChange: PropTypes.func,
};

PasswordField.defaultProps = {
  value: '',
  type: 'password',
  onChange: null,
};

export default PasswordField;
